import { useTranslation } from 'react-i18next';
import { useProfileStore } from '../stores/profileStore';
import { useNavigate } from 'react-router-dom';
import { useProfileRole } from '../hooks/useProfileRole';
import { Button } from '../components/common/Button';
import NotificationsSection from '../components/dashboard/NotificationsSection';
import JobsSection from '../components/dashboard/JobsSection';
import CreditSection from '../components/dashboard/CreditSection';
import ContactSection from '../components/dashboard/ContactSection';
import QuotesSection from '../components/dashboard/QuotesSection';
import ProjectsSection from '../components/dashboard/ProjectsSection';
import { COMPANY_TYPES } from '../types/profile';

const Dashboard = () => {
  const { profile } = useProfileStore();
  const { t } = useTranslation(['common', 'dashboard', 'notifications', 'jobs']);
  const navigate = useNavigate();
  const { isRecruiter, isFreelancer } = useProfileRole();

  const handleCreateOffer = () => {
    navigate('/jobs', {
      state: {
        openCreate: true,
      },
    });
  };

  return (
    <div className="mb-8 flex flex-col gap-6 md:min-h-[calc(100vh-4rem)] md:gap-8 md:px-5 lg:px-32">
      {isRecruiter &&
        profile?.company_type === COMPANY_TYPES.ORGANIZATION &&
        profile?.obnl_review_status === 'pending' && (
          <section
            data-testid="obnl-review-banner"
            className="rounded-2xl border border-amber-300 bg-amber-50 px-5 py-4 text-amber-900"
          >
            <h2 className="text-lg font-semibold">{t('dashboard:organizationReview.title')}</h2>
            <p className="mt-1 text-sm">{t('dashboard:organizationReview.description')}</p>
          </section>
        )}
      <div className="flex w-full flex-col gap-6 pb-1 pt-2 md:flex-row md:items-stretch md:justify-between md:pb-8 md:pt-1">
        <div className="flex min-w-0 flex-1 flex-col justify-between">
          <div className="flex min-w-0 flex-col">
            <h1 className="break-words pb-0 text-4xl font-normal not-italic leading-tight text-secondary md:mb-1 md:text-7xl lg:text-8xl">
              {t('dashboard:greeting')}
            </h1>
            <h2 className="font-ambit break-words text-4xl italic leading-tight text-secondary md:text-7xl lg:text-8xl">
              {profile?.first_name}
            </h2>
          </div>

          {isRecruiter && (
            <Button
              type="submit"
              className="mt-3 w-full text-sm md:mt-10 md:w-auto md:px-5 md:max-w-96"
              onClick={handleCreateOffer}
            >
              {t('create_offer_button', { ns: 'jobs' })}
            </Button>
          )}
        </div>

        <div className="flex-col shrink-0 justify-between rounded-2xl border-2 border-gray-300 bg-white p-5 drop-shadow-xl md:flex md:max-h-64 md:w-56 md:items-end lg:w-[350px]">
          <NotificationsSection />
        </div>
      </div>

      {isRecruiter && <JobsSection />}

      {isFreelancer && <QuotesSection />}

      <ProjectsSection />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="min-w-0 flex-1">
          <ContactSection />
        </div>
        <div className="min-w-0 flex-1">
          <CreditSection />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
